<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Terms"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <label>Terms and Conditions</label>
              <div class="editor-container">
                <ValidationProvider
                  ref="description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <vue-editor
                    :error-messages="errors"
                    v-model="data.description"
                    :editor-toolbar="customToolbar"
                  ></vue-editor>
                </ValidationProvider>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>
<style>
.editor-container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 20px;
}

.vue-editor {
  border: none;
}

.vue-editor .ql-editor {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  color: #333;
}

.vue-editor .ql-toolbar {
  background-color: #f5f5f5;
  border: none;
  border-radius: 4px;
  padding: 8px;
}

.vue-editor .ql-toolbar button {
  padding: 8px;
  color: #333;
}

.vue-editor .ql-toolbar button:hover {
  background-color: #eee;
}

.vue-editor .ql-toolbar button.ql-active {
  background-color: #ddd;
}
</style>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import { VueEditor } from "vue2-editor";
export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm, VueEditor },
  computed: {
    ...mapState({
      status: state => state.Terms.status
    })
  },
  data() {
    return {
      storeName: "Terms",
      title: "Terms and Conditions",
      data: {
        description: ""
      },
      customToolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image", "video"],
        ["blockquote", "code-block"],
        ["clean"]
      ]
    };
  }
};
</script>
